import { render, staticRenderFns } from "./cargoInquiry-list.vue?vue&type=template&id=2bcdedbe&scoped=true"
import script from "./cargoInquiry-list.vue?vue&type=script&lang=js"
export * from "./cargoInquiry-list.vue?vue&type=script&lang=js"
import style0 from "./cargoInquiry-list.vue?vue&type=style&index=0&id=2bcdedbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcdedbe",
  null
  
)

export default component.exports